import { render, staticRenderFns } from "./StudySelect.vue?vue&type=template&id=55a0e1be&"
import script from "./StudySelect.vue?vue&type=script&lang=js&"
export * from "./StudySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports